module.exports = __webpack_public_path__ + "static/media/t-SNE.24f39702.svg";